import * as actionTypes from "../../constants/actionTypes";
import {
  getOfferExtraGroup,
  getOfferExtraGroups
} from "../../api/offerExtraGroup";

const invalidateOfferExtraGroups = () => {
  return {
    type: actionTypes.INVALIDATE_OFFER_EXTRA_GROUPS_DATA
  };
};

const loadOfferExtraGroup = (clientConfig, offerExtraGroupId) => {
  return {
    type: actionTypes.LOAD_OFFER_EXTRA_GROUP_DATA,
    promise: getOfferExtraGroup(clientConfig, offerExtraGroupId)
  };
};

const loadOfferExtraGroups = (clientConfig, dataStatus) => {
  return {
    type: actionTypes.LOAD_OFFER_EXTRA_GROUPS_DATA,
    promise: getOfferExtraGroups(clientConfig, dataStatus)
  };
};

export {
  invalidateOfferExtraGroups,
  loadOfferExtraGroup,
  loadOfferExtraGroups
};
